var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "single-folded-content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "K\\xF8bskontrakt-/-Oversigt",
    transform: "translate(-117.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "single-folded-content",
    transform: "translate(118.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#424242",
    points: "8.82608696 0.304347826 8.82608696 3.95652174 12.4782609 3.95652174"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#424242",
    points: "8.82608696 0.304347826 8.82608696 3.95652174 12.4782609 3.95652174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#424242",
    strokeLinecap: "square",
    points: "8.82608696 0.304347826 0.304347826 0.304347826 0.304347826 13.6956522 12.4782609 13.6956522 12.4782609 3.95652174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34782609,3.95652174 L5.7826087,3.95652174",
    id: "Path",
    stroke: "#424242",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34782609,7 L9.43478261,7",
    id: "Path",
    stroke: "#424242",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34782609,10.0434783 L9.43478261,10.0434783",
    id: "Path",
    stroke: "#424242",
    strokeLinecap: "square"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.b797673413a8b5d9a1eef61b9085ab5d.svg";
export { ForwardRef as ReactComponent };